// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
	<path d="M9.2,12h5.6c0.6,0,1,0.5,1,1c0,0.3-0.1,0.5-0.3,0.7L12,17.3l-3.5-3.6c-0.4-0.4-0.4-1,0-1.4C8.7,12.1,8.9,12,9.2,12z" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-arrow-down-triangle-CC_2NjvY.js.map
